
import { OrderAndDeliveryInventoryVO } from "@/views/biz/mypage/vo/mypage.vo";
import axios from "axios";
import { Component, Prop, Vue } from "vue-property-decorator";
import DeliveryAddressChoicePop from "./DeliveryAddressChoicePop.vue";
import { MstOrderVO, OrderMetaVO, RelOrderProductVO } from "./vo/order.vo";
import CommonModalDialog from "@/components/CommonModalDialog.vue";

@Component({
  components: { DeliveryAddressChoicePop, CommonModalDialog },
})
export default class OrderDetail extends Vue {
  @Prop() orderCd!: string;
  @Prop() orderStatusCd!: string;

  order = {} as MstOrderVO;
  products = [] as Array<RelOrderProductVO>;
  orderMeta = {} as OrderMetaVO;

  // 취소 불가 팝업
  disabledCancelAlert = false;
  purchaseCompleteAlert = false;


  // 현재 system locale이 ko임?
  get isZikoo(): boolean {
    if (process.env.VUE_APP_SYSTEM_LOCALE == "ko") {
      return true;
    }
    return false;
  }

  // 주소 변경 가능?
  get canChangeAddress(): boolean {
    if (this.order.deliveryType != "01") {
      // 택배만 가능(픽업은 변경 불가)
      return false;
    }
    let result = false;
    this.products.forEach((product) => {
      if (product.orderStatusCd != "004022") {
        result = false;
        return;
      }
      result = true;
    });

    return result;
  }

  // 클레임 신청 가능?
  get isRegistClaim(): boolean {
    return (
      this.products.filter((product) =>
        product.orderStatusCd.startsWith("00402")
      ).length > 0
    );
  }

  // 주소 변경
  saveAddress(): void {
    if (!confirm(this.$t("order.c0003").toString())) {
      // 배송 정보를 변경하시겠습니까?
      return;
    }
    axios.put("/order/address", this.order).then(() => {
      this.$toast(this.$t("order.a0027"));
    });
  }

  // 반품 가능?
  canReturn(product: RelOrderProductVO): boolean {
    // 홍콩출발(일반), 홍콩출발(홍콩), 배송완료, 픽업완료
    return (
      product.orderStatusCd == "004032" ||
      product.orderStatusCd == "004036" ||
      product.orderStatusCd == "004040" ||
      product.orderStatusCd == "004041"
    );
  }

  // 결제하기
  goPayment() {
    this.$router.push("/order/payment/" + this.order.orderCd);
  }

  // 클레임 접수
  goClaim(item: RelOrderProductVO) {
    // 상품준비중
    if (item.orderStatusCd.startsWith("00402")) {
      // 인도일 확정일 경우 취소 불가
      if (this.order.dptrTimeFixYn == "Y") {
        this.disabledCancelAlert = true;
        return;
      }
    }

    // 배송완료(반품접수)
    if (this.canReturn(item)) {
      this.$router.push({
        name: "OrderClaimDetail",
        params: {
          claimType: "return",
          orderCd: item.orderCd.toString(),
          orderProductSeq: item.seq.toString(),
        },
      });
    }
    // 나머지는 취소접수
    else {
      this.$router.push({
        name: "OrderClaimDetail",
        params: {
          claimType: "cancel",
          orderCd: item.orderCd.toString(),
          orderProductSeq: item.seq.toString(),
        },
      });
    }
  }

  // 전체취소
  fullCancel() {
    this.$router.push({
      name: "OrderClaimDetail",
      params: { claimType: "cancel", orderCd: this.orderCd },
    });
  }

  // 다시 구매
  repurchase(item: OrderAndDeliveryInventoryVO) {
    this.$router.push(`/product/${item.productCd}`);
  }

  // orderStatusCd가 일치하는 상품정보 가져오기
  getProductsByProductType(productType: string): Array<RelOrderProductVO> {
    const result: Array<RelOrderProductVO> = [];
    this.products.forEach((product) => {
      if (product.productType == productType) {
        result.push(product);
      }
    });
    return result;
  }

  // 상품 그룹(group by 하는게 의미 없어 상품 정보의 첫행만 가져옴)
  getProductGroupByProductType(productType: string): Array<RelOrderProductVO> {
    const result = this.getProductsByProductType(productType);
    return result && result.length ? [result[0]] : [];
  }

  // 같은 주문에 다른 상품 타입이 존재하는지 여부
  isMixedProductTypesByOrderCd() {
    return !!(
      this.getProductGroupByProductType("01").length &&
      this.getProductGroupByProductType("02").length
    );
  }

  // 배송조회
  searchDelivery() {
    window.open(`${this.products[0].courierUrl}/${this.products[0].invcNo}`);
  }

  purchaseComplete() {
    const param: OrderAndDeliveryInventoryVO =
      {} as OrderAndDeliveryInventoryVO;
    param.orderCd = this.order.orderCd;

    axios.put("mypage/order/purchase-decide", param).then(
      () => {
        this.purchaseCompleteAlert = false;
        this.$router.push({ name: "ConfirmPurchase" });
      },
      () => {
        this.purchaseCompleteAlert = false;
      }
    );
  }

  // init
  created() {
    axios.get(`/mypage/order/${this.orderCd}`).then(
      (r) => {
        if (r.data.order) {
          this.order = r.data.order;
          this.products = r.data.products;
          this.orderMeta = r.data.orderMeta;
        } else {
          this.$router.push("/mypage/order/orders/all");
        }
      },
      () => {
        alert(this.$t("common.a0001"));
      }
    );
  }
}
